import type { ShellAuthUser } from '../../../shared/app-context/domain/ports/ShellAuthApplicationPort.ts';

/** Maps an arbitrary user object to a ShellAuthUser. */
export function toShellAuthUser(user: unknown): ShellAuthUser | null {
  if (!user || typeof user !== 'object') return null;
  const u = user as Record<string, unknown>;
  const raw = u.id;
  const idStr =
    raw != null &&
    raw !== '' &&
    (typeof raw === 'string' || typeof raw === 'number' || typeof raw === 'bigint')
      ? String(raw)
      : '';
  if (!idStr) return null;
  const permissionsRaw = u.permissions;
  const permissions =
    Array.isArray(permissionsRaw) && permissionsRaw.length > 0
      ? permissionsRaw.filter((x): x is string => typeof x === 'string')
      : undefined;
  const emailStr = typeof u.email === 'string' ? u.email.trim() : '';
  const nombrePersona = typeof u.nombre === 'string' ? u.nombre.trim() : '';
  const nombreUsuario = typeof u.nombre_usuario === 'string' ? u.nombre_usuario.trim() : '';
  const displayNameRaw =
    nombreUsuario ||
    (typeof u.displayName === 'string' ? u.displayName.trim() : '') ||
    (typeof u.name === 'string' ? u.name.trim() : '') ||
    (typeof u.fullName === 'string' ? u.fullName.trim() : '') ||
    emailStr ||
    '';
  return {
    id: idStr,
    email: emailStr || undefined,
    nombre: nombrePersona || undefined,
    displayName: displayNameRaw || undefined,
    role: typeof u.role === 'string' ? u.role : undefined,
    permissions: permissions?.length ? permissions : undefined,
  };
}
